module.exports = __webpack_public_path__ + "static/img/02.c9880c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/02.png
// module id = TRu7
// module chunks = 1